// Copyright (c) 2020 Deere & Company

import PropTypes from 'prop-types';
import React from 'react';

const Placeholder = props => {

    const placeholderOption = (
        <option value="-1">
            {props.text}
        </option>
    );

    return placeholderOption;

};

Placeholder.displayName = 'Placeholder';
Placeholder.propTypes = {
    text: PropTypes.string
};

export default Placeholder;
